export default {
  campaign: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/layouts/campaign.vue").then(m => m.default || m),
  default: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/layouts/default.vue").then(m => m.default || m)
}